import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-465bb0d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "swiper-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src", "alt"]

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Autoplay } from 'swiper/modules'

import mainAdsListJson from '@/assets/data/main-ad-list.json'

interface Ad {
  name: string;
  img: string;
  link: string;
  description: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MainAdsSwiper',
  setup(__props) {

const mainAdsList = mainAdsListJson as Ad[]

const openNewTab = (url?: string) => {
  if (url) window.open(url, '__blank')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      class: "main-ads-swiper",
      pagination: { type: 'fraction' },
      "space-between": 16,
      "slides-per-view": 'auto',
      "free-mode": false,
      loop: true,
      autoplay: { delay: 5000, disableOnInteraction: false },
      speed: 700,
      modules: [_unref(Pagination), _unref(Autoplay)]
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainAdsList), (ad) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), {
            key: `b-content-${ad.name}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "b-content",
                onClick: ($event: any) => (openNewTab(ad.link))
              }, [
                _createElementVNode("img", {
                  class: "b-content__img",
                  src: ad.img,
                  alt: ad.description ?? 'b-content image'
                }, null, 8, _hoisted_3)
              ], 8, _hoisted_2)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}
}

})